import React, { Component } from 'react';
import { Switch, Route, Redirect, withRouter } from 'react-router-dom';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import IdleMonitor from 'react-simple-idle-monitor';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';

import isTouch from 'is-touch';
import { fetchDirectors, fetchPhotographers, fetchShopOverview, fetchCart, fetchLatest, fetchScreensavers } from '../actions';

import Header from './layout/Header';
import Footer from './layout/Footer';

import Latest from './pages/latest.jsx';
import Artists from './pages/artists.jsx';
import Director from './pages/director.jsx';
import Photographer from './pages/photographer.jsx';
import ArtistInformation from './pages/artist_information.jsx';
import Job from './pages/job.jsx';
import Video from './pages/video.jsx';
import Covid from './pages/Covid.jsx';
import Information from './pages/Information';
import Shop from './pages/Shop';
import ShowProduct from './pages/ShowProduct';
import Faq from './pages/Faq';
import Terms from './pages/Terms';

import Cart from './parts/Cart';
import Intro from './parts/intro.jsx';
import Screensaver from './parts/screensaver.jsx';

class App extends Component {
  constructor(props){
    super(props);

    this.state = {
      headerLabel: false,
      showIntro: false,
      idle: false
    }
  }

  componentWillMount(){
    this.props.fetchPhotographers();
    this.props.fetchDirectors();
    this.props.fetchLatest();
    this.props.fetchShopOverview();
    this.props.fetchScreensavers();
  }

  componentDidMount(){
    document.body.classList.add('ready');

    // if(!localStorage.getItem('dismiss_intro')){
      // this.setState({showIntro: true});

      setTimeout(() => {
        this.setState({showIntro: false}, () => {
          // localStorage.setItem('dismiss_intro', 'true');
        });
      }, 2500)
    // }
  }

  _handleVideoMount = label =>{
    this.setState({
      headerLabel: label
    });
  }

  _handlePhotoMount = (label, photo, total) =>{
    this.setState({
      headerLabel: label,
      videoDuration: `${photo} / ${total}`
    });
  }

  _handleUnmount = () =>{
    this.setState({
      headerLabel: false,
    });
  }

  shouldComponentUpdate(nextProps, nextState){
    // console.log('should updat                                                  äöe?', nextProps, nextState);
    // if(
    //   this.props.history !== nextProps.history ||
    //   this.props.match !== nextProps.match ||
    //   this.state.showIntro !== nextState.showIntro ||
    //   this.state.showShopIntro !== nextState.showShopIntro ||
    //   this.state.idle !== nextState.idle ||
    //   this.props.location !== nextProps.location
    // ){
    //   return true;
    // }
    return true;
  }
  render () {
    const { location } = this.props;

    // REVIEW: check reliability
    // NOTE: remove trailing numbers and slashes to prevent animation between job slides
    // NOTE: could be hard when an artist name starts numeric, but let's see

    const cleanPathname = location.pathname.replace(/\b([\/][0-9]+)/gm, () => '');

    return <IdleMonitor
        activeClassName="app"
        idleClassName="app app--idle"
        timeout={30000}
        onIdle={() => this.setState({idle: true})}
        onActive={() => this.setState({idle: false})} >
        <React.Fragment>
          <Helmet>
            <title>AKKURAT Studios</title>
            <meta name='description' content='We act as an artist-driven production and publishing company. Managing award-winning talent coming from a variety of acknowledged constellations.' />
            <meta name='og:title' content='AKKURAT Studios' />
            <meta name='og:description' content='We act as an artist-driven production and publishing company. Managing award-winning talent coming from a variety of acknowledged constellations.' />
            <meta name='og:type' content='Website' />
          </Helmet>
          {!isTouch &&
            <React.Fragment>
              <Screensaver active={this.state.idle} />
            </React.Fragment>
          }
          <Intro visible={this.state.showIntro} />
          <Header
            label={this.state.headerLabel}
            />
          <Cart />
          <div className='router'>
            <TransitionGroup>
              <CSSTransition
                key={cleanPathname}
                classNames="transition"
                timeout={600}
                appear={true}
                mountOnEnter={true}
                unmountOnExit={false}>
                  <Switch location={location} >
                    <Route exact path='/' component={Latest} />
                    <Route exact path='/photographers/:slug/' component={Photographer} />
                    <Route path='/photographers/:slug/:job/:photo' render={() =>
                        <Job
                          onPhotoMount={(label, photo, total) => this._handlePhotoMount(label, photo, total)}
                          onUnmount={() => this._handleUnmount()} />
                    } />
                    <Route exact path='/directors/:slug/' component={Director} />
                    <Route exact path='/directors/:slug/:id' render={() =>
                        <Video
                          idle={this.state.idle}
                          onMount={(video) => this._handleVideoMount(video)}
                          onUnmount={() => this._handleUnmount()} />
                    } />
                    <Route path='/covid-19' render={() => <Covid />} />
                    <Route path='/artists' render={() => <Artists />} />
                    <Route exact path='/shop' component={() => <Shop />} />
                    <Route path='/shop/faq' component={Faq} />
                    <Route path='/shop/terms' component={Terms} />
                    <Route
                      exact
                      path='/shop/products/:handle'
                      render={({ match }) => (
                        <Redirect to={`/shop/${match.params.handle}`} />
                      )}
                    />
                    <Route path='/shop/:handle' component={({match}) => <ShowProduct handle={match.params.handle}/>} />

                    <Route path='/cart' component={Cart} />
                    <Route path='/information' component={Information} />
                  </Switch>
              </CSSTransition>
            </TransitionGroup>
          </div>
          {/*<CookieNotice />*/}
        </React.Fragment>
      </IdleMonitor>;
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    directors: state.directors,
    photographers: state.photographers,
    latest: state.latest,
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    fetchDirectors: () => {
      dispatch(fetchDirectors());
    },
    fetchPhotographers: () => {
      dispatch(fetchPhotographers());
    },
    fetchLatest: () => {
      dispatch(fetchLatest());
    },
    fetchScreensavers: () => {
      dispatch(fetchScreensavers());
    },
    fetchShopOverview: () => {
      dispatch(fetchShopOverview());
    },
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App)) ;
